/**
 * Created by zhangrp on 2018/4/3.
 */

import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';
import shopDevcApi from '../../api/shopDevc';

import SwbMsuListByGoodsCatIdAndServicerIdForSelect from './MsuListByGoodsCatIdAndServicerIdForSelect';
Vue.regist(SwbMsuListByGoodsCatIdAndServicerIdForSelect);
import SwbMsuListByGoodsIdAndMerchantIdForSelect from './MsuListByGoodsIdAndMerchantIdForSelect';
Vue.regist(SwbMsuListByGoodsIdAndMerchantIdForSelect);

import SwbServcGoodsCatRelSelect from './ServcGoodsCatRelSelect.vue';
Vue.regist(SwbServcGoodsCatRelSelect);

import  SwbMsuListForSelect from './MsuListForSelect';
Vue.regist(SwbMsuListForSelect);
// 质保外服务选择列表
export function openMsuListByGoodsCatIdDlg(params, callback) {
    let goodsCatId = params['goodsCatId'] || null;
    let servicerId = params['servicerId'] || null;
    let servcType = params['servcType'];
    let contractId = params['contractId'] || null;
    let goodsCatIds = params['goodsCatIds'] || null;
    let comnOnlyFlag = params['comnOnlyFlag'];
    Vue.$showDialog({
        title: "服务选择列表",
        width: 1200,
        height: 600,
        showCloseBtn: true,
        template: '<div>' +
        '<swb-msu-list-by-goodsCatId-and-servicerId-for-select :goodsCatIds="goodsCatIds" :comnOnlyFlag="comnOnlyFlag" :contractId="contractId" :type="type" :goodsCatId="goodsCatId" :servicerId="servicerId" ref="swb_msu_list_by_goodsCatId_and_servicerId_for_select"></swb-msu-list-by-goodsCatId-and-servicerId-for-select>' +
        '</div>',
        data: {
            goodsCatId: goodsCatId,
            servicerId: servicerId,
            type: servcType,
            contractId: contractId,
            goodsCatIds: goodsCatIds,
            comnOnlyFlag: comnOnlyFlag,
        },
        methods: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_msu_list_by_goodsCatId_and_servicerId_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                let msu = result.data;
                callback(msu);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        cancelClicked: function () {
        },
    });
}

import  SwbSpecServcSelect from './SpecServcSelect';
Vue.regist(SwbSpecServcSelect);
// 质保外服务选择列表
export function openSpecServcSelectDlg(params, callback) {
    Vue.$showDialog({
        title: "服务选择列表",
        width: 1200,
        height: 600,
        showCloseBtn: true,
        template: '<div>' +
        '<swb-spec-servc-select :paramsFilter="params" ref="swb_spec_servc_select"></swb-spec-servc-select>' +
        '</div>',
        data: {
            params: params
        },
        methods: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_spec_servc_select.getDlgResult() || {};
            if(result.type == 'info') {
                let msu = result.data;
                callback(msu);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

// 质保内服务选择列表
export function openMsuListByGoodsIdDlg(params, callback) {
    let goodsId = params['goodsId'] || null;
    let srcVendorId = params['srcVendorId'] || null;
    let sellerType = params['sellerType'];
    let servcType = params['servcType'];
    let comnOnlyFlag = params['comnOnlyFlag'];
    let theDlg = Vue.$showDialog({
        title: "服务选择列表",
        width: 1000,
        height: 650,
        template: '<swb-msu-list-by-goodsId-and-merchantId-for-select :type="type" :comnOnlyFlag="comnOnlyFlag" :goodsId="goodsId" :srcVendorId="srcVendorId" :sellerType="sellerType" ref="swb_msu_list_by_goodsId_and_merchantId_for_select"></swb-msu-list-by-goodsId-and-merchantId-for-select>',
        data: {
            goodsId: goodsId,
            comnOnlyFlag: comnOnlyFlag,
            srcVendorId: srcVendorId,
            sellerType: sellerType,
            type: servcType,
        },
        methods: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_msu_list_by_goodsId_and_merchantId_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                let msu = result.data;
                callback(msu);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}
export function selectRedioServcGoodsCatRel(filter, callback) {
    //
    let merchantId = filter.merchantId;
    let merchantType = filter.merchantType;
    let servcId = filter.servcId;
    let type = filter.servcType;
    Vue.$showDialog({
        title: '服务-选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        okVisible: true,
        template: '<div>' +
        '<swb-servc-goods-cat-rel-list :type="type" :merchantId="merchantId" :merchantType="merchantType" :servcId="servcId" ref="swb_servc_goods_cat_rel_list"></swb-servc-goods-cat-rel-list>' +
        '</div>',
        data: {
            servcId: servcId,
            merchantId: merchantId,
            merchantType: merchantType,
            type: type,
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_servc_goods_cat_rel_list.getDlgResult() || {};
            if(result.type == "info") {
                let servcGoodsCatRel = result.data;
                //
                callback(servcGoodsCatRel);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

export function openServcDlg(filter, callback) {
    let objectId = filter.merchantId;
    let objectType = filter.merchantType;
    let checkedIds = filter.checkedIds;
    let checkBox = filter.checkBox;
    let type = filter.type;
    let comnOnlyFlag = filter.comnOnlyFlag;
    let voucherType = filter.voucherType;
    let productOrMaint = filter.productOrMaint;
    let allType = filter.allType || false;
    Vue.$showDialog({
        title: '服务-选择',
        width: 900,
        height: 700,
        showCloseBtn: true,
        okVisible: true,
        template: '<div>' +
        '<swb-msu-list-for-select :allType="allType" :voucherType="voucherType" :type="type" :comnOnlyFlag="comnOnlyFlag" :productOrMaint="productOrMaint" :objectId="objectId" :objectType="objectType" :checkedIds="checkedIds" :checkBox="checkBox" ref="swb_msu_list_for_select"></swb-msu-list-for-select>' +
        '</div>',
        data: {
            objectId: objectId,
            objectType: objectType,
            checkedIds: checkedIds,
            checkBox: checkBox,
            type: type,
            comnOnlyFlag: comnOnlyFlag,
            productOrMaint: productOrMaint,
            voucherType: voucherType,
            allType: allType
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_msu_list_for_select.getDlgResult() || {};
            if(result.type == "info") {
                let servcList = result.data;
                //
                callback(servcList);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/servc/selectDlg.js
// module id = 66
// module chunks = 0